export const dummyData = ($http: HttpApi) => ({
  create: (params: HttpParams['body'] = {}) => $http.$post('/dummy_data', { body: params }),
  get: () => $http.$get('/dummy_data'),
});
